import * as React from 'react'
import { configOptions } from './config'

export const TreePlusPlusDescription = {
  name: 'Tree++',
  component: React.lazy(() => import('./TreePlusPlus' )),
  label: 'Tree++ [EXPERIMENTAL, NOT READY FOR PRODUCTION]',
  variables: configOptions,
}
